import { DisplayCurrentAddress } from 'components/address/DisplayCurrentAddress';
import { COUNTRY_CODE_NZ } from '_config';
import { yesNoOptions, numbersOnlyPattern, residentialStatusOptions } from '../_constants';
import { lengthOfCurrentResidencyValidationMessages, showPreviousAddress } from './otherDetails';

export const biometricsAddressDetails = [
  {
    component: 'Select',
    name: 'residentialStatus',
    label: 'Residential status',
    testId: 'residential-status',
    options: residentialStatusOptions,
    validate: {
      messages: {
        required: 'Please select residential status.',
      },
    },
  },
  {
    condition: (values, store) => store.biometricsResult?.address && values.changeAddress !== true,
    component: 'CustomComponent',
    children: DisplayCurrentAddress,
  },
  {
    component: 'Address',
    condition: (values, store) => !store.biometricsResult?.address || values?.changeAddress,
    name: 'currentAddress',
    label: 'Current residential address',
    testId: 'current-residential-address',
    allowPropertyName: false,
    allowPO: false,
    countryCode: COUNTRY_CODE_NZ,
    autoAddressErrorMessage: 'Please enter your current NZ residential address.',
    autoAddressHelpText: 'We do not accept PO Box or international addresses',
  },
  {
    component: 'RadioGroup',
    name: 'isPostalSameWithResidential',
    label: 'This is also my mailing address',
    testId: 'is-postal-same-with-residential',
    options: yesNoOptions,
    showCircles: true,
    validate: {
      messages: {
        required: 'Is your postal address the same as your current residential address?',
      },
    },
  },
  {
    condition: values => values.isPostalSameWithResidential === 'no',
    component: 'Address',
    name: 'postalAddress',
    label: 'Postal address',
    testId: 'postal-address',
    allowPropertyName: false,
    allowPO: true,
    countryCode: COUNTRY_CODE_NZ,
    autoAddressErrorMessage: 'Please enter your postal address.',
  },
  {
    component: 'TimeSpan',
    name: 'lengthOfCurrentResidency',
    label: 'Length of time at current residential address',
    testId: 'current-residential-address-length',
    validate: {
      props: { minYears: 0, maxYears: 99, minMonths: 0, maxMonths: 11, validPattern: numbersOnlyPattern },
      messages: lengthOfCurrentResidencyValidationMessages,
      component: 'TimeSpan',
    },
  },
  {
    condition: values => showPreviousAddress(values.lengthOfCurrentResidency),
    name: 'previousAddressGroup',
    fields: [
      {
        condition: values => values.hasNonDomesticPreviousAddress === false,
        component: 'Address',
        name: 'previousAddress',
        label: 'Previous residential address',
        testId: 'previous-residential-address',
        allowPropertyName: false,
        allowPO: false,
        countryCode: COUNTRY_CODE_NZ,
        autoAddressErrorMessage: 'Please provide your previous NZ address or confirm that it was not in NZ.',
      },
      {
        component: 'Checkbox',
        name: 'hasNonDomesticPreviousAddress',
        label: '',
        children: 'My previous address was not in New Zealand',
        testId: 'previous-address-non-domestic',
        validate: false,
      },
    ],
  },
];
